import axiosInstance from "./axios";

export class ContenidoService {
    getTemas(params) {
        return axiosInstance
            .get(`/tema/temacontenido`, { params })
            .then((res) => res.data)
    }

    getModulos() {
        return axiosInstance
            .get("/modulo")
            .then((res) => res.data)
    }

    getCiclos() {
        return axiosInstance
            .get("/ciclo")
            .then((res) => res.data)
    }

    addTema(dto) {
        return axiosInstance
            .post("/tema", dto)
            .then((res) => res.data)
    }

    updateTema(dto) {
        return axiosInstance
            .put(`/tema/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteTema(id) {
        return axiosInstance
            .delete(`/tema/${id}`)
            .then((res) => res.data)
    }

    addSubTema(dto) {
        return axiosInstance
            .post("/contenido", dto)
            .then((res) => res.data)
    }

    updateSubTema(dto) {
        return axiosInstance
            .put(`/contenido/${dto._id}`, dto)
            .then((res) => res.data)
    }

    copiarContenido(dto) {
        return axiosInstance
            .post(`/tema/copiartemacontenido`, dto)
            .then((res) => res.data)
    }
}
